import { render, staticRenderFns } from "./AssetList.vue?vue&type=template&id=8ffa2670&scoped=true&"
import script from "./AssetList.vue?vue&type=script&lang=js&"
export * from "./AssetList.vue?vue&type=script&lang=js&"
import style0 from "./AssetList.vue?vue&type=style&index=0&id=8ffa2670&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffa2670",
  null
  
)

export default component.exports